// extracted by mini-css-extract-plugin
export default {"buttonTab":"ButtonTab_buttonTab__ZIuxJ"};